<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Invoice with Term Receiving Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-form-row>
                        <b-col md="5">
                            <b-input-group >
                                <b-input-group-prepend><label>PO/SO No.</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.po" :state="!$v.model.pohdrkey.$error"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuPorderShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col>
                            <b-input-group >
                                <b-input-group-prepend><label>Supplier/Vendor</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.vendorinfo" ></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-form-row>   
                    <b-form-row>
                        <b-col md="5">
                            <b-input-group >
                                <b-input-group-prepend><label>Term of Number</label></b-input-group-prepend>
                               <b-form-select v-model="model.namaterm" :plain="true" :options="invoiceTerms" :state="!$v.model.namaterm.$error" :disabled="editDisabled" style="width:40% !important;"></b-form-select>
                                  <b-input-group-append> <span class="p-2">pc</span></b-input-group-append>
                                <b-form-input type="number" v-model="model.persentase" ></b-form-input>
                                  <b-input-group-append> <span class="input-group-text"><i class="fa fa-percent"></i></span></b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col md="5">
                            <b-input-group >
                                <b-input-group-prepend><label >Term Amount</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.nilai" :precision="2" :state="!$v.model.nilai.$error"></my-number>
                            </b-input-group>
                        </b-col>
                    </b-form-row>   
                    <b-input-group >
                        <b-input-group-prepend><label>Term Condition / <br/> Document Required</label></b-input-group-prepend>
                        <b-form-textarea :rows="3" :max-rows="10" v-model="model.syarat" :disabled="editDisabled"></b-form-textarea>
                    </b-input-group>
                    <b-row>
                        <b-col md="6">                            
                        <b-input-group>
                            <b-input-group-prepend><label>Receiving Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.komplitDate" type="date"  :state="!$v.model.komplitDate.$error"></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                        <b-col md="6">
                        <b-input-group>
                            <b-form-checkbox v-model="model.komplit" value=1 unchecked-value=0 :state="!$v.model.komplit.$error">
                             Required items & Documents for Invoicing is Complete
                            </b-form-checkbox>
                        </b-input-group>
                        </b-col>
                    </b-row >    
                </b-col>
              </b-row>
              
                <div class="report-wraper">
                    <table style="width: 99%;">
                        <thead>
                            <tr>
                                <th width="20px">No.</th>
                                <th width="180px">Item Code</th>
                                <th width="300px">Item Name</th>
                                <th >Description</th>
                                <th width="100px">Outstand<br>Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in model.lines" :key="row.podtlkey">
                                <td>{{row.lineno}}</td>
                                <td>{{row.partnumber}}</td>
                                <td>{{row.itemname}}</td>
                                <td>{{row.description}}</td>
                                <td  style="text-align:center;">{{row.quantity}} {{row.unitsize}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>                  
            <b-row class="justify-content-center mb-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </b-row>

        </b-card>
        <b-modal v-model="lkuPorderShow" size="lg" :hide-footer="true" title="List of Purchase/Service Order" :centered="true">
            <lku-porder @click="onSelectLkuPorder"></lku-porder>
        </b-modal>        
    </div>
</template>
<style lang="scss">
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
        table {
            font-size: smaller;
            th {
                border: 1px solid silver;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }

            td {
                border: 1px solid silver;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
        }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import lkuPorder from "../lookup/lkuPorder.1";
import procure from "../../apis/procure";
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber,lkuPorder},
  mixins: [validationMixin],
  validations: {
        model: {
            komplit: { required },
            komplitDate: { required },
            // potermkey: { required },
            nilai: { required, minValue:minValue(0.00000001) },
            pohdrkey: { required },
            namaterm: { required },
        },
  }, 
  data() {
    return {
        saveEnabled:true,
        editDisabled:false,
        lkuPorderShow:false,
        model:{matauang:this.$store.state.user.matauang, komplitDate:'', vendor:'', namaterm:'', syarat:'', lines:[],terms:[]},
        invoiceTerms: [{ value: '', text: '-' }, { value: 'Term#1', text: 'Term#1' }, { value: 'Term#2', text: 'Term#2' },
                        { value: 'Term#3', text: 'Term#3' }, { value: 'Term#4', text: 'Term#4' }
                ],
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return (this.$v.model.$invalid && (this.model.komplit==1)) ;
    },
    namaterm(){
        return this.model.namaterm;
    },
  },
  watch: {
    namaterm: function(newval) {
        this.onChangeTerm(newval);
    },    
  },
  created: async function(){
    //   this.currency = await procure.currency();
    if (this.$route.params.pohdrkey)  {
          toastr.info('Loading Order Detail, please wait')
          try {
            const data = await procure.detail(this.$route.params);  
            const row = data[0][0];
            this.model.po = row.orderno;
            row.komplitDate = row.komplitDate ? moment(row.komplitDate).format('YYYY-MM-DD') : '';
            row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.lines = data[1];
            this.model.terms = data[2];
            // change termin
            const selected = data[2].find(x=> x.potermkey === this.$route.params.potermkey);
            this.model.totalinv = 0;
            this.model.potermkey = '';
            if (selected)
            {
                this.model.termin = selected.namaterm;
                this.model.namaterm = selected.namaterm;
                this.model.syarat = selected.syarat;
                this.model.totalinv = selected.nilai;
                this.model.nilai = selected.nilai;
                this.model.potermkey = selected.potermkey;
                this.model.komplit = selected.komplit;
                this.model.komplitDate=selected.komplitDate?moment(selected.komplitDate).format('YYYY-MM-DD'):'';
                this.saveEnabled=selected.komplitDate?false:true;   
                this.editDisabled=selected.komplitDate?true:false;   
            }
            
            // this.onChangeTerm(this.model.termin);
            // this.ordLines.items = data[1];
            // this.model.terms = data[2];
            // this.calcTotalDtlOrder();
            // this.tanggalBerubah();
            //     this.updateDimHdr = !this.updateDimHdr;
                // this.$forceUpdate();                
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } 
  },
  methods: {
    save: async function () {
        // :state="!$v.model.potermkey.$error"        
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        
        if (this.model.komplit != 1) {
            toastr.warn('Save only when Required Items/Documents completed');
            return;
        }
        if (this.invalidModel) {
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
                const row={};
                for (var key in this.model) {
                    row[key] = this.model[key];
                }
                row.potermkey = this.model.potermkey || '';
                row.komplitDate = moment(this.model.komplitDate).format('YYYY-MM-DD');
                row.komplit = this.model.komplit ;
                row.pohdrkey = this.model.pohdrkey;

                await procure.invoiceTermin(row);
                toastr.success("Complete successfully", "Save Order");
                this.close();
            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "Save Order Error");                
            }

        }
    },
    async onSelectLkuPorder(_selected) {
        this.model.pohdrkey = _selected.pohdrkey;
        this.model.po = _selected.orderno;
        this.model.vendor = _selected.vendor;
        this.model.vendorinfo = _selected.vendor_name.trim() + ' | ' + _selected.vendor_code;
        this.model.matauang = _selected.matauang;
        this.model.totalinv = 0;
        try {
            // this.isLoading=true;
            const data = await procure.detail({ pohdrkey: _selected.pohdrkey }) ;
            this.model.lines = data[1];
            this.model.terms = data[2];
            // const row = data[0][0];
            this.onChangeTerm(this.model.namaterm);
        } catch (error) {
            // this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
        this.lkuPorderShow=false;
    },
    onChangeTerm : function (termin) {
        const selected = this.model.terms.find(x=> x.namaterm === termin);
        this.model.totalinv = 0;
        this.model.potermkey = '';
        if (selected)
        {
            this.model.syarat = selected.syarat;
            this.model.totalinv = selected.nilai;
            this.model.potermkey = selected.potermkey;
        }
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'procurement.receivingfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'payable.apinv'});
          router.push("home");
      }
    }
  }
};
</script>
